<mat-form-field>
    <mat-label>Currency</mat-label>
    <mat-select [(ngModel)]="selectedCurrency" (ngModelChange)="onCurrencyChange()">
        <mat-option value="USD">USD</mat-option>
        <mat-option value="CAD">CAD</mat-option>
    </mat-select>
</mat-form-field>